var _filter, _filter2, _pattern, _rect, _path, _path2, _path3, _rect2, _rect3, _line, _line2, _line3, _rect4, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _circle, _circle2, _circle3, _line22, _line23, _path4, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _rect5, _text, _text2, _text3, _rect6, _text4, _text5, _text6, _rect7, _circle10, _text7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalAntenna(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "antennaGlow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "dishGlow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "antennaGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#00ffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#00cccc",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#009999",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "centerGlow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#00ffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    style: {
      stopColor: "#00cccc",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#009999",
      stopOpacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dishGradient",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#00ffff",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#00cccc",
      stopOpacity: 0.1
    }
  }))), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 25,
    height: 25,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25 0 L 0 0 0 25",
    fill: "none",
    stroke: "rgba(0, 255, 255, 0.08)",
    strokeWidth: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "url(#grid)",
    opacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 50 350 Q 100 340 150 350 Q 200 360 250 350 Q 300 355 350 350",
    fill: "none",
    stroke: "rgba(0, 255, 255, 0.15)",
    strokeWidth: 1,
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 30 370 Q 80 365 130 370 Q 180 375 230 370 Q 280 372 330 370",
    fill: "none",
    stroke: "rgba(0, 255, 255, 0.15)",
    strokeWidth: 1,
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 40 390 Q 90 385 140 390 Q 190 395 240 390 Q 290 392 340 390",
    fill: "none",
    stroke: "rgba(0, 255, 255, 0.15)",
    strokeWidth: 1,
    opacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 280,
    width: 60,
    height: 80,
    fill: "rgba(0, 0, 0, 0.3)",
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 0.8,
    rx: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 285,
    width: 50,
    height: 70,
    fill: "none",
    stroke: "#00cccc",
    strokeWidth: 1.5,
    opacity: 0.6,
    rx: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 300,
    x2: 230,
    y2: 300,
    stroke: "#00ffff",
    strokeWidth: 1,
    opacity: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 320,
    x2: 230,
    y2: 320,
    stroke: "#00ffff",
    strokeWidth: 1,
    opacity: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 340,
    x2: 230,
    y2: 340,
    stroke: "#00ffff",
    strokeWidth: 1,
    opacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 200,
    width: 10,
    height: 80,
    fill: "rgba(0, 0, 0, 0.4)",
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 0.9,
    rx: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 195,
    y1: 220,
    x2: 205,
    y2: 220,
    stroke: "#00cccc",
    strokeWidth: 1,
    opacity: 0.6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 195,
    y1: 240,
    x2: 205,
    y2: 240,
    stroke: "#00cccc",
    strokeWidth: 1,
    opacity: 0.6
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 195,
    y1: 260,
    x2: 205,
    y2: 260,
    stroke: "#00cccc",
    strokeWidth: 1,
    opacity: 0.6
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 220,
    x2: 230,
    y2: 220,
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 0.8
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 240,
    x2: 230,
    y2: 240,
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 0.8
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 260,
    x2: 230,
    y2: 260,
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 0.8
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 280,
    x2: 200,
    y2: 220,
    stroke: "#00cccc",
    strokeWidth: 1.5,
    opacity: 0.6
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 280,
    x2: 200,
    y2: 220,
    stroke: "#00cccc",
    strokeWidth: 1.5,
    opacity: 0.6
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 180,
    rx: 100,
    ry: 50,
    fill: "url(#dishGradient)",
    stroke: "#00ffff",
    strokeWidth: 3,
    opacity: 0.9,
    filter: "url(#dishGlow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.7;1;0.7",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 180,
    rx: 90,
    ry: 45,
    fill: "none",
    stroke: "#00cccc",
    strokeWidth: 2,
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;0.9;0.6",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 180,
    rx: 80,
    ry: 40,
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 1.5,
    opacity: 0.7
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 180,
    rx: 70,
    ry: 35,
    fill: "none",
    stroke: "#00cccc",
    strokeWidth: 1.2,
    opacity: 0.6
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 180,
    rx: 60,
    ry: 30,
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 1,
    opacity: 0.8
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 180,
    rx: 50,
    ry: 25,
    fill: "none",
    stroke: "#00cccc",
    strokeWidth: 1,
    opacity: 0.7
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 180,
    rx: 40,
    ry: 20,
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 1,
    opacity: 0.9
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 180,
    rx: 30,
    ry: 15,
    fill: "none",
    stroke: "#00cccc",
    strokeWidth: 1,
    opacity: 0.8
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 180,
    rx: 20,
    ry: 10,
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 1.2,
    opacity: 0.9
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 180,
    x2: 200,
    y2: 130,
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 0.8
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 180,
    x2: 200,
    y2: 230,
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 0.8
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 180,
    x2: 140,
    y2: 180,
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 0.8
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 180,
    x2: 260,
    y2: 180,
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 0.8
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 180,
    x2: 170,
    y2: 150,
    stroke: "#00cccc",
    strokeWidth: 1.5,
    opacity: 0.6
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 180,
    x2: 230,
    y2: 150,
    stroke: "#00cccc",
    strokeWidth: 1.5,
    opacity: 0.6
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 180,
    x2: 170,
    y2: 210,
    stroke: "#00cccc",
    strokeWidth: 1.5,
    opacity: 0.6
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 180,
    x2: 230,
    y2: 210,
    stroke: "#00cccc",
    strokeWidth: 1.5,
    opacity: 0.6
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 180,
    x2: 155,
    y2: 165,
    stroke: "#00cccc",
    strokeWidth: 1,
    opacity: 0.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 180,
    x2: 245,
    y2: 165,
    stroke: "#00cccc",
    strokeWidth: 1,
    opacity: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 180,
    x2: 155,
    y2: 195,
    stroke: "#00cccc",
    strokeWidth: 1,
    opacity: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 180,
    x2: 245,
    y2: 195,
    stroke: "#00cccc",
    strokeWidth: 1,
    opacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 180,
    r: 12,
    fill: "rgba(0, 0, 0, 0.6)",
    stroke: "#00ffff",
    strokeWidth: 2,
    opacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "12;16;12",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.8;1",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 180,
    r: 6,
    fill: "url(#centerGlow)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "6;8;6",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.7;1",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 180,
    r: 3,
    fill: "#00ffff",
    opacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;4;3",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 180,
    x2: 200,
    y2: 130,
    stroke: "#00ffff",
    strokeWidth: 4,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 200 180",
    to: "360 200 180",
    dur: "6s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.4;1;0.4",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 180,
    x2: 200,
    y2: 130,
    stroke: "#00cccc",
    strokeWidth: 2,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 200 180",
    to: "360 200 180",
    dur: "6s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.8;0.2",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 100 180 Q 150 160 200 180 Q 250 200 300 180",
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 1.5,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.8;0.2",
    dur: "2.5s",
    repeatCount: "indefinite"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 3,
    fill: "#00ffff",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;1;0.3",
    dur: "1.8s",
    repeatCount: "indefinite"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 150,
    r: 3,
    fill: "#00ffff",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;1;0.3",
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "0.4s"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 210,
    r: 3,
    fill: "#00ffff",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;1;0.3",
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "0.8s"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 210,
    r: 3,
    fill: "#00ffff",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;1;0.3",
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "1.2s"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 170,
    r: 2,
    fill: "#00cccc",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.8;0.2",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.2s"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 170,
    r: 2,
    fill: "#00cccc",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.8;0.2",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.6s"
  }))), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 190,
    r: 2,
    fill: "#00cccc",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.8;0.2",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s"
  }))), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 190,
    r: 2,
    fill: "#00cccc",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.8;0.2",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.4s"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 80,
    height: 50,
    fill: "rgba(0, 0, 0, 0.4)",
    stroke: "#00ffff",
    strokeWidth: 1.5,
    opacity: 0.7,
    rx: 5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 35,
    textAnchor: "middle",
    fontFamily: "Courier New, monospace",
    fontSize: 10,
    fill: "#00ffff",
    opacity: 0.9
  }, "RADAR SYSTEM")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 50,
    textAnchor: "middle",
    fontFamily: "Courier New, monospace",
    fontSize: 9,
    fill: "#00ffff",
    opacity: 0.8
  }, "STATUS: ACTIVE")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 65,
    textAnchor: "middle",
    fontFamily: "Courier New, monospace",
    fontSize: 8,
    fill: "#00cccc",
    opacity: 0.7
  }, "FREQ: 2.4GHz")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 20,
    width: 80,
    height: 50,
    fill: "rgba(0, 0, 0, 0.4)",
    stroke: "#00ffff",
    strokeWidth: 1.5,
    opacity: 0.7,
    rx: 5
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 35,
    textAnchor: "middle",
    fontFamily: "Courier New, monospace",
    fontSize: 10,
    fill: "#00ffff",
    opacity: 0.9
  }, "SIGNAL DATA")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 50,
    textAnchor: "middle",
    fontFamily: "Courier New, monospace",
    fontSize: 9,
    fill: "#00ffff",
    opacity: 0.8
  }, "STRENGTH: 98%")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 65,
    textAnchor: "middle",
    fontFamily: "Courier New, monospace",
    fontSize: 8,
    fill: "#00cccc",
    opacity: 0.7
  }, "RANGE: 50KM")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 350,
    width: 60,
    height: 30,
    fill: "rgba(0, 0, 0, 0.4)",
    stroke: "#00ffff",
    strokeWidth: 1,
    opacity: 0.6,
    rx: 3
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 365,
    r: 3,
    fill: "#00ff00",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.5;1;0.5",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 370,
    fontFamily: "Courier New, monospace",
    fontSize: 8,
    fill: "#00ffff",
    opacity: 0.8
  }, "ONLINE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalAntenna);
export default __webpack_public_path__ + "static/media/digital-antenna.91d2df3dfbde7123dbb60df189514836.svg";
export { ForwardRef as ReactComponent };